export default __webpack_public_path__ + "static/media/other.51ce6024.png";